import { useFormikContext } from "formik";
import { OrDropdown } from "../shared_modules/ui/components/atoms/or-dropdown/or-dropdown";
import { useProvinces } from "./useProvinces";

export function ProvinceSelect(props) {
  const [provinces] = useProvinces();
  const { setFieldValue } = useFormikContext();

  let view = "";

  if (provinces) {
    view = (
      <div className="or-auth-form__group">
        <OrDropdown
          disableClearable={true}
          errorText={props.touched.province ? props.errors.province : ""}
          getOptionLabel={(option) => {
            let id = option;
            if (option.id) {
              id = option.id;
            }

            const selectedProvince = provinces.find((province) => province.id === id);
            return selectedProvince ? selectedProvince.name : "";
          }}
          hasError={props.touched.province && Boolean(props.errors.province)}
          isOptionEqualToValue={(option, selectedValue) => {
            const selectedId = typeof selectedValue === "string" ? selectedValue : selectedValue && selectedValue.id;
            return option.id === selectedId;
          }}
          label="Provincia *"
          name="province"
          onChange={(_event, value) => {
            if (value) {
              setFieldValue("province", value.id);
            }
          }}
          options={provinces}
          theme={props.theme}
          value={provinces.find((province) => province.id === props.value) || null}
        />
      </div>
    );
  }

  return view;
}
